import styled from 'styled-components';
import { Typography } from '@material-ui/core';

export const AppBarTitle = styled(Typography)`
  flex-grow: 1;
`;
